export const renderMetricValue = value => {
  return value ? value : '-'
}
